// export const BACKEND_SERVICE_BASE_URL = 'https://certificate-api-qa.vibalgroup.com'
export const BACKEND_SERVICE_BASE_URL = 'https://certificate-generator-api.vibal.ph'
// export const BACKEND_SERVICE_BASE_URL = 'http://localhost:8686'
export const HIDDEN_DATA_SECRET = '1qf+r!p'
export const HIDDEN_DATA_TOKEN_EXP = '1d'
export const USER_LIST_COLUMN_FORMAT = ["Attendee's Name", "Email Address", "Date Attended", "Topic"]
export const UPLOAD_DATA_ERROR = ["INCOMPLETE", "INVALID_EMAIL"]